<div class="faq-page">
    <section class="faq-hero animate-fade-in-up" aria-label="Knowledge Base">
        <div class="faq-hero__container">
            <div class="faq-hero__eyebrow">Knowledge Base</div>
            <h1 class="faq-hero__title">Frequently Asked<br />Questions.</h1>

            <div class="faq-list">
                <article class="faq-card">
                    <h2 class="faq-card__question">
                        How do Agentic AI Workflows explicitly reduce operational drag?
                    </h2>
                    <div class="faq-card__answer">
                        Rêve deploys autonomous L0 agents that interface directly with internal APIs to intercept,
                        reason, and resolve complex workflows entirely without human intervention. This aggressive,
                        zero-touch task deflection mathematically lowers the baseline cost per execution while
                        compounding efficiency month-over-month.
                    </div>
                </article>

                <article class="faq-card">
                    <h2 class="faq-card__question">
                        What is the functional difference between L0 and L1 AI Support architectures?
                    </h2>
                    <div class="faq-card__answer">
                        <strong>L0 (Zero-Touch)</strong> represents fully autonomous AI agents that resolve user
                        requests directly by altering data and executing tasks securely.
                        <strong>L1 (Copilot-Augmented)</strong> involves human engineers who are actively assisted by
                        AI—the AI instantly surfaces topological similarities, deep articles, and pre-compiled scripts
                        to severely accelerate the human's time-to-resolution.
                    </div>
                </article>

                <article class="faq-card">
                    <h2 class="faq-card__question">
                        Is my proprietary data safe when integrating Large Language Models?
                    </h2>
                    <div class="faq-card__answer">
                        Absolutely. We engineer strict Zero-Trust AI environments and localized RAG (Retrieval-Augmented
                        Generation) pipelines. We ensure your corporate intellectual property never bleeds into public
                        large language model (LLM) training datasets, guaranteeing absolute compliance with ISO 27001
                        and GDPR standards.
                    </div>
                </article>
            </div>
        </div>
    </section>

    <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
        <div class="contact-section__container">
            <div class="contact-section__grid">
                <div>
                    <div class="contact-section__eyebrow">Connect</div>
                    <div class="contact-section__title">Discover the future of applied AI.</div>
                    <div class="contact-section__copy">
                        Connect with our delivery experts to audit your topology and map your enterprise integration
                        roadmap.
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-card__corner" aria-hidden="true"></div>
                    <div class="contact-card__title">Direct Inquiry</div>

                    <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <div>Request securely logged. Our architecture team will reach out within one business day.
                        </div>
                    </div>

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
                        <div class="contact-form__field">
                            <input type="text" formControlName="name" placeholder="Full Name" />
                        </div>

                        <div class="contact-form__row">
                            <div class="contact-form__field">
                                <input type="email" formControlName="email" placeholder="Corporate Email" />
                            </div>
                            <div class="contact-form__field">
                                <input type="text" formControlName="company" placeholder="Organization" />
                            </div>
                        </div>

                        <div class="contact-form__field">
                            <textarea rows="3" formControlName="message"
                                placeholder="Brief context of operational challenges..."></textarea>
                        </div>

                        <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                            class="contact-form__submit">
                            <span *ngIf="!isSubmitting">Transmit Request</span>
                            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Encrypting...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->
</div>
